module.exports = __webpack_public_path__ + "static/media/back.4fecd4c4.svg";